// extracted by mini-css-extract-plugin
export var bannerImage = "bam-rewards-module--bannerImage--ae3f5";
export var blueStackOverlay = "bam-rewards-module--blueStackOverlay--d498c";
export var column = "bam-rewards-module--column--6c33d";
export var link = "bam-rewards-module--link--e68c9";
export var list = "bam-rewards-module--list--e762e";
export var overlay1 = "bam-rewards-module--overlay1--2203e";
export var storeButtons = "bam-rewards-module--storeButtons--49a14";